import React,  { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { highestUsage } from "../model/e_highest-usage-days-service";
import InputBase from '@material-ui/core/InputBase';
import { store } from "../../../../helpers/store";
import {useDispatch} from  'react-redux';
import {useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    fontSize: "15px",
    color: theme.palette.eDark?.base,
    padding: '10px 26px 10px 12px',
    '&:focus': {
      borderRadius: 4,
    },
  },

}))(InputBase);
export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    color: theme.palette.eRich?.base + " !important",
    fontSize: "0.8rem",
  },
}))(MenuItem);
export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    color: theme.palette.eDark?.base + " !important",
    fontSize: "0.8rem",
    border: "1px solid " + theme.palette.eLight?.base + " !important",
    borderRadius: "4px",
    padding: "0.4rem 0.625rem",
    justifyContent: "flex-start",
  },
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
    whiteSpace: "pre-line",
  },
  icon: {
    color: theme.palette.eDark?.base,
  },
}))(Select);

const useStyles = makeStyles((theme) => ({
  margin: {
    marginTop: theme.spacing(0),
  },
}));

export default function DatesDropdown(props) {  
  const useStyleClasses = useStyles();
  const [value, setValue] = React.useState("");
  const [datePickerIsOpen, setDatePickerIsOpen] = React.useState(false);
  const {t:Labels, ready: labelReady} = useTranslation("label-HIGHEST_USAGE");
  const saStartDate = useSelector((state) => state?.meterDetails?.getSaInfo?.saStartDate);

const primaryLanguageCode = useSelector(
  (state) =>
    state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
);
  const [dropDownData, setDropDownData] = useState();
  useEffect(() => {
    if(i18next.language){
    store.getState().snackbar = true;
    highestUsage.getDropdownData("E_HIGHEST_USAGE_TIME",i18next.language).then((resp) => {
      let dropdown= resp?.data?.getDropdownData?.filter(data => data?.dropDownCode !== 'E_HIGHEST_USAGE_PREVIOUS_MONTH');
      setDropDownData(dropdown);
      setValue(dropdown[0]['dropDownCode']);
      store.getState().snackbar = false;
    })
    .catch((err) => {
      store.getState().snackbar = false;
      setDropDownData(null);
      setValue("");
    })
    
  }}, [primaryLanguageCode,i18next]);
  useEffect(()=>{
    if(dropDownData)
      setValue(dropDownData[0]['dropDownCode']);
  },[dropDownData]);
  const closePicker=()=>{
    setDatePickerIsOpen(false);
  }

  const customClickHandler = (customDropdownCode) => {
    if (customDropdownCode === "E_HIGHEST_USAGE_CUSTOM") {
      setDatePickerIsOpen(true);
    }
  }
  const displayDropdownChange = (event) => {
    store.getState().snackbar = true;
    setValue(event.target.value)  
    let endDate
    let startDate 

    if (event.target.value === 'E_HIGHEST_USAGE_CURRENT_MONTH') {
        endDate =   moment().subtract('months').endOf('month').format('YYYY-MM-DD');
        startDate = moment().subtract('months').startOf('month').format('YYYY-MM-DD');
        props.filterPeriod(startDate,endDate);
    } else if (event.target.value === "E_HIGHEST_USAGE_LAST_MONTH") {
        endDate =   moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD');
        startDate = moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD');
        props.filterPeriod(startDate,endDate);
    } 
    store.getState().snackbar = false;
  };
  const handleChangeDate = (event) => {
    setDatePickerIsOpen(false);
    let endDate =   moment(event).endOf('month').format('YYYY-MM-DD');
    let startDate = moment(event).startOf('month').format('YYYY-MM-DD');
    props.filterPeriod(startDate,endDate);
  };
  
  return (
    <Grid><Grid item>
        <STYLED_SELECT className={useStyleClasses.margin}
        id="demo-customized-select-native"
        value={value}
        onChange={displayDropdownChange}
        input={<BootstrapInput />}
        onClick={props.monthRender}
        variant="outlined"
        IconComponent={ExpandMoreSharpIcon}
        MenuProps={{
          disableScrollLock: false,
          anchorOrigin: {
              vertical: "bottom"
          },
          transformOrigin: {
              vertical: "top"
          },
          getContentAnchorEl: null
      }}
        >
          {dropDownData?.map((element,index) => (
            <STYLED_MENU_ITEM key={index} value={element?.dropDownCode} 
            onClick={(event) => customClickHandler(element?.dropDownCode)}
            >{element?.dropDownValue}</STYLED_MENU_ITEM>
          ))}
       </STYLED_SELECT>
       <MuiPickersUtilsProvider utils={DateFnsUtils}>       
        <KeyboardDatePicker
            cancelLabel={<span onClick={closePicker}>{labelReady && Labels("HIGHEST_USAGE_CANCEL")}</span>}
            okLabel ={<span >{labelReady && Labels("HIGHEST_USAGE_OK")}</span>} 
            maxDate={moment()}
            minDate={moment(saStartDate)}
            views={["year", "month"]}
            onChange={handleChangeDate}
            inputVariant="standard" 
            open={datePickerIsOpen}
            TextFieldComponent={() => null}
          />  
        </MuiPickersUtilsProvider>

      </Grid>
    </Grid>
  );
}